import { render, staticRenderFns } from "./attachment-list.vue?vue&type=template&id=c2f4f4ce&"
import script from "./attachment-list.vue?vue&type=script&lang=js&"
export * from "./attachment-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports